<template>
  <div class="d-flex flex-row align-baseline">
    <div style="width: 48px">
      <TextField
          :value="hours"
          @keypress="onKeyPressHours"
          @input="onInputHours"
          @focusout="onFocusOutHours"
      />
    </div>
    ：
    <div style="width: 48px;">
      <TextField
          :value="minutes"
          @keypress="onKeyPressMinutes"
          @input="onInputMinutes"
          @focusout="onFocusOutMinutes"
      />
    </div>
  </div>
</template>

<script>
import TextField from "@/components/atoms/TextField";
import ComponentMixin from "@/components/ComponentMixin";
export default {
  mixins: [ComponentMixin],
  type: "molecule",
  name: "TimeField",
  components: {TextField},
  props: {
    value: {
      type: String,
    }
  },
  data () {
    return {
      openPicker: false,
      hours: this.parseHours(),
      minutes: this.parseMinutes()
    }
  },
  methods: {
    parseHours() {
      if (this.value == null) {
        return null;
      }
      return this.value.substr(0, 2);
    },
    parseMinutes() {
      if (this.value == null) {
        return null;
      }
      return this.value.substr(3, 2);
    },
    onInputHours (value) {
      this.onInput(value, this.minutes);
    },
    onInputMinutes (value) {
      this.onInput(this.hours, value);
    },
    onInput(hours, minutes) {
      hours = this.toNumberString(hours);
      minutes = this.toNumberString(minutes);
      this.hours = hours;
      this.minutes = minutes;
      if (hours == null || minutes == null) {
        this.$emit("input", null);
      } else {
        hours = ("00" + hours).slice(-2);
        minutes = ("00" + minutes).slice(-2);
        this.$emit("input", `${hours}:${minutes}`);
      }
    },
    onKeyPressHours (event) {
      this.onKeyPressValue(event, this.hours)
    },
    onKeyPressMinutes (event) {
      this.onKeyPressValue(event, this.minutes)
    },
    onKeyPressValue (event, value) {
      if (value && value.length === 2) {
        if (event.target && (event.target.selectionEnd - event.target.selectionStart) === 0) {
          event.preventDefault();
          return false;
        }
      }
      event = event ? event : window.event;
      const code = event.which ? event.which : event.keyCode;
      if (code >= '0'.charCodeAt(0) && code <= '9'.charCodeAt(0)) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    onFocusOutHours () {
      if (this.hours) {
        this.hours = this.toNumberString(this.hours);
        this.hours = ("00" + this.hours).slice(-2);
        const result = this.hours.match(/^\d{2}$/g)
        this.hours = result ? result[0] : null;
        this.onInput(this.hours, this.minutes);
      }
    },
    onFocusOutMinutes () {
      if (this.minutes) {
        this.minutes = this.toNumberString(this.minutes);
        this.minutes = ("00" + this.minutes).slice(-2);
        const result = this.minutes.match(/^\d{2}$/g)
        this.minutes = result ? result[0] : null;
        this.onInput(this.hours, this.minutes);
      }
    }
  },
  watch: {
    value: {
      handler: function () {
        if (this.hours == null) {
          this.hours = this.parseHours();
        }
        if (this.minutes == null) {
          this.minutes = this.parseMinutes();
        }
      }
    }
  }
}
</script>

<style scoped>

</style>